// Adds Tailwind variables to the global scope
import "./setup/tailwind-setup.js";

// Import JavaScript components
// import './components/accordion';
// import './components/tabs';
// import './components/toggle';

//If you want cookie consent
// import "./modules/cookie-consent";

//If you need a class to be toggled on a different element
// import "./modules/toggle";

//If you need to do something when its in/out of the viewport
// import "./modules/intersects";

import Swiper from "swiper";
import { Autoplay, Pagination } from "swiper";

window.Swiper = Swiper;
window.Swiper.use([Autoplay, Pagination]);

document.getElementById("body").onload = () => {
	document.getElementById("logo")?.classList.toggle("active");
};

document.getElementById("menutoggle").onclick = () => {
	document.getElementById("menutoggle").classList.toggle("btn--menu-active");
	document.getElementById("mainmenu").classList.toggle("active");
	document.getElementById("mainmenu").setAttribute("aria-hidden", "false");
	document.getElementById("body").classList.toggle("menu-active");

	if (document.getElementById("menutoggle").classList.contains("btn--menu-active")) {
		document.getElementById("menutoggle").innerHTML = "Close";
		document.getElementById("mainmenu").setAttribute("aria-hidden", "false");
	} else {
		document.getElementById("menutoggle").innerHTML = "Menu";
		document.getElementById("mainmenu").setAttribute("aria-hidden", "true");
	}
};

new window.Swiper("#partnersCarousel", {
	slidesPerView: 2,
	spaceBetween: 20,
	autoplay: {
		delay: 2000,
	},
	breakpoints: {
		450: {
			slidesPerView: 3,
		},
		768: {
			slidesPerView: 4,
		},
		991: {
			slidesPerView: 6,
		},
	},
});

if (document.getElementById("twoColCarousel")) {
	if (window.innerWidth < 1024) {
		document.getElementById("twoColCarousel").classList.add("swiper");
		document.getElementById("twoColCarousel").classList.add("swiper-container");
		document.getElementById("twoColCarouselWrapper").classList.add("swiper-wrapper");
	} else {
		document.getElementById("twoColCarousel").classList.remove("swiper");
		document.getElementById("twoColCarousel").classList.remove("swiper-container");
		document.getElementById("twoColCarouselWrapper").classList.remove("swiper-wrapper");
	}
}

new window.Swiper("#twoColCarousel", {
	slidesPerView: 1,
	spaceBetween: 20,
	breakpoints: {
		768: {
			slidesPerView: 2,
		},
	},
	pagination: {
		el: ".two-col-pagination",
		type: "bullets",
		clickable: true,
	},
});

// FAQ Accordion Code

var questions = document.querySelectorAll(".accordion-heading");

if (questions) {
	questions.forEach(function (item) {
		item.addEventListener(
			"click",
			function (e) {
				questions.forEach(function (item) {
					item.parentElement.classList.remove("active-accordion");
				});
				item.parentElement.classList.toggle("active-accordion");
			},
			false,
		),
			item.addEventListener(
				"focus",
				function (e) {
					questions.forEach(function (item) {
						item.parentElement.classList.remove("active-accordion");
					});
					item.parentElement.classList.toggle("active-accordion");
				},
				false,
			);
	});
}

if (document.getElementById("share-btn")) {
	document.getElementById("share-btn").onclick = () => {
		document.getElementById("share-btn").classList.add("active");
	};
}
